export default "__VITE_ASSET__Ce0UOd1t__"